export const supportedLngs = ["es", "en", "ro"];
export const idsCompaniesTrazabilitySection = [1, 164];
